<rt-select2
  #filterSelect
  [formControl]="filterSelectControl"
  [groupedItems]="filterSelectOptions?.options ?? []"
  [hiddenItems]="hiddenItems"
  [autoClose]="false"
  [itemsLoading]="filterSelectOptions ? !filterSelectOptions.loaded : true"
  [overlayWidth]="250"
  [overlayPosition]="overlayPosition"
  [disableLocalSearch]="true"
  [searchControl]="searchControl"
  [vsCompareItems]="vsCompareItems"
  (vsEnd)="onScrollEnd($event)"
  withGroups
  withSearch
  withMultiselect
  alwaysOpen
>
  <ng-template rtSelectTrigger></ng-template>
  <rt-select-header>
    @if (filterSelectOptions?.groupDef || backAlwaysVisible) {
      <rt-icon-button iconName="arrow-back" variant="plain" prefix (click)="onBackClick()" />
    }
    @if (filterSelectOptions?.groupDef; as groupDef) {
      {{ groupDef.name }}
    }
    @if (!filterSelectOptions?.groupDef) {
      {{ placeholder | translate }}
    }
  </rt-select-header>
  <ng-container
    *rtSelectListItem="
      filterSelect;
      let selectCtrl;
      let item = item;
      let isHoverState = isHoverState
    "
  >
    <rt-dropdown-item (click)="onItemClick(item)" [class.hover]="isHoverState">
      @if (!isFilterGroup(item.value)) {
        <rt-checkbox
          prefix
          [checked]="selectCtrl.itemSelector.isSelected(item)"
          [hasMargin]="false"
          (valueChange)="onItemClick(item)"
        />
      }
      <div layout layout-align-items-center>
        <rt-icon [name]="item.icon!" margin-right-small-x />
        <span>{{ item.label }}</span>
        @if (isFilterGroup(item.value)) {
          <rt-icon name="chevron-right" margin-left-auto />
        }
      </div>
    </rt-dropdown-item>
  </ng-container>
</rt-select2>
